import CryptoJS from 'crypto-js';
import { btoa, atob } from '../../lib/helpers';
import { postApi } from '../../lib/fetcher';

const dashboardProfiling = {
  namespaced: true,

  state() {
    return {
      grafikTransaksi: null,
      loading: false,
      flashErrorMessage: '',
      allActiveWilayah: [],
    };
  },

  mutations: {
    getDataGrafikTransaction(state, { payload }) {
      state.grafikTransaksi = payload.data;
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    setActiveWilayah(state, { payload }) {
      state.allActiveWilayah = payload;
    },
  },

  actions: {
    async getCountTransaksi(ctx, { date, search }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        search,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/dashboard/merchant-profiling/get-data-card-total`;

      const responseData = await postApi(ctx, urlApi, data);

      return responseData?.data.total_transaction;
    },

    async getSalesVolume(ctx, { date, search }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        search,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/dashboard/merchant-profiling/get-data-card-volume`;

      const responseData = await postApi(ctx, urlApi, data);

      return responseData?.data.total_amount;
    },

    async getGrafikWilayah(ctx, { date, search }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        search,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/dashboard/merchant-profiling/get-transaction-area`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('getDataGrafikTransaction', { payload: responseData });
      }
    },

    async fetchActiveArea(ctx, { date }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        version: btoa(
          CryptoJS.SHA256(
            `${date}${atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))}`
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/dashboard/merchant-profiling/get-area`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setActiveWilayah', {
          payload: responseData.data,
        });
      }
    },
  },
};
export default dashboardProfiling;
